/**
 * Provides an interface for modifying a `Document` associated with a directory.
 * @module app/views/Documents/DirectoryEditView
 */
import Backbone from "backbone";
import _ from "underscore";
var DirectoryEditView = Backbone.View.extend({
  className: "form directory-edit",

  tagName: "div",

  template: _.template(
    '<div class="form-group"><label class="control-label" for="dir-name">Name</label><input type="text" value="<%= model.attributes.Name %>" id="dir-name" class="dir-name form-control"/></div>'
  ),

  /**
   * Initializes the view.
   * @param  {object} options The options hash.
   * @param {Document} options.model The model to update.
   */
  initialize: function (options) {
    this.options = _.defaults({}, options);
  },

  render: function () {
    this.$el.html(this.template(this.options));

    return this;
  },

  /**
   * Commit the changes to the model.
   */
  commit: function () {
    this.options.model.set("Name", this.$(".dir-name").val());
  },
});

export default DirectoryEditView;



//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/documents/DirectoryEditView.js
// module id = 894
// module chunks = 1